import {ReelConstants, SymbolSizes} from '@gongxigames/framework/slot';

export class GameReelConstants extends ReelConstants {
    public static DEFAULT_DIMENSION = 3;
    public static MAX_DIMENSIONS_ROW = 5;
    // @ts-ignore: TODO: refactor
    public static DIMENSION_SYMBOL_SIZES: SymbolSizes[] = [null, null, null, {
        width: 552,
        height: 480
    }, {
        width: 552,
        height: 360
    }, {
        width: 552,
        height: 288
    }];
    // @ts-ignore: TODO: refactor
    public static DIMENSION_SYMBOL_SLOT_SIZES: SymbolSizes[] = [null, null, null, {
        width: 552,
        height: 480
    }, {
        width: 552,
        height: 360
    }, {
        width: 552,
        height: 288
    }];
}
